<template>
    <!-- 文化活动 -->
    <div class="activity">
        <BasePage ref='basePage'>
            <template scope="{item}">
                <div class="item_box" @click="toDetail(item)" :key="item.id">
                    <el-image class="item_img" :src="item.coverUrl" >
                        <div slot="placeholder" class="image_slot">
                            <i class="el-icon-loading"></i>
                        </div>
                    </el-image>
                    <div class="item_activity" :class="item.activityStatus?'status_1':'status_0'" >{{item.statusName}}</div>
                    <div class="item_info">
                        <div class="item_title ellipsis">{{item.title}}</div>
                        <div class="item_date">时间：{{item.startTime}} ~ {{item.endTime}}</div>
                        <div class="item_address">地址：{{item.addr}}</div>
                        <div class="item_peoples">
                            <i class="el-icon-user" style="font-size:16px;margin-right:7px;"></i>
                            <span style="color: #07bb3f;"> {{item.bms}} 人报名</span>
                        </div>
                        <div>
                            <img class="item_footer_icon user_icon" :src="item.venueLogo" alt="">
                            <span style="font-size:14px; vertical-align: middle;">{{item.venueName}}</span>
                        </div>
                    </div>
                </div>
            </template>
        </BasePage>
    </div>
</template>

<script>
import BasePage from '@c/BasePage'

export default {
    name: 'activity',
    components: {
        BasePage
    },
    data () {
        return {

        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.basePage.loadImage(to.query.id)
        next()
    },
    methods: {
        toDetail(item) {
            this.$router.push(`/activity/detail/${item.id}`)
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.activity {
    background: #f8f8f8;
    .item_box {
        width: 285px;
        margin: 0 20px 20px 0;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        &:nth-child(4n) {
            margin-right: 0;
        }
        .item_activity {
            position: absolute;
            top: 12px;
            left: 12px;
            width: 72px;
            height: 25px;
            line-height: 25px;
            border-radius: 25px 25px 25px 0;
            font-weight: 400;
            text-align: center;
            color: #fff;
            font-size: 14px;
            
        }
        .item_img {
            width: 100%;
            height: 132px;
            ::v-deep {
                img {
                    object-fit: cover;
                }
            }
        }
        .image_slot {
            text-align: center;
            padding-top: 50px;
            font-size: 30px;
        }
        .item_info {
            padding: 18px;
            line-height: 1;
            color: #777;
        }
        .item_title {
            font-size: 18px;
            color: #000;
            margin-bottom: 20px;
        }
        .item_date, .item_address, .item_peoples {
            font-size: 14px;
            padding-bottom: 16px;
        }
        .item_peoples {
            
        }
        .item_icon {
            width: 16px;
            height: 16px;
            margin-right: 7px;
        }
        .user_icon {
            overflow: hidden;
            border-radius: 50%;
        }
        .item_footer_icon {
            width: 32px;
            height: 32px;
            margin-right: 7px;
        }
    }
}
</style>